import React from 'react'
import Header from '../../../component/layout/header'
import { Outlet } from 'react-router'
import useNav from '../../../component/custom-hooks/get-nav'

const StockSupplyInvConfigLayout = () => {
  const navList = useNav();
  let { StockSupplyConfigBottom, StockConfigTopHeader } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={StockSupplyConfigBottom} topTabs={StockConfigTopHeader} />
      <Outlet />
    </div>
  )
}

export default StockSupplyInvConfigLayout
